/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import Accordion from '../components/Accordion/Accordion';
import AgendaTable from '../components/AgendaTable/AgendaTable';
import ArticlePagination from '../components/ArticlePagination/ArticlePagination';
import ArticleShare from '../components/ArticleShare/ArticleShare';
import Articles from '../components/Articles/Articles';
import ArticlesDetail from '../components/ArticlesDetail/ArticlesDetail';
import AsymmetricCardCarousel from '../components/AsymmetricCardCarousel/AsymmetricCardCarousel';
import BreadcrumbNavigation from '../components/BreadcrumbNavigation/BreadcrumbNavigation';
import ButtonGroup from '../components/ButtonGroup/ButtonGroup';
import CardSection from '../components/CardSection/CardSection';
import CardSwiper from '../components/CardSwiper/CardSwiper';
import CaseStudy from '../components/CaseStudy/CaseStudy';
import ComparisonCardGroup from '../components/ComparisonCardGroup/ComparisonCardGroup';
import ContentCardSlider from '../components/ContentCardSlider/ContentCardSlider';
import CoreStrengthsGrid from '../components/CoreStrengthsGrid/CoreStrengthsGrid';
import DeliveryApproach from '../components/DeliveryApproach/DeliveryApproach';
import DocumentLibrary from '../components/DocumentLibrary/DocumentLibrary';
import DownloadDetail from '../components/DownloadDetail/DownloadDetail';
import DownloadResource from '../components/DownloadResource/DownloadResource';
import ErrorPage from '../components/ErrorPage/ErrorPage';
import Events from '../components/Events/Events';
import EventsDetail from '../components/Events/EventsDetail';
import EventsSwiper from '../components/Events/EventsSwiper';
import Upcoming from '../components/Events/Upcoming';
import Faq from '../components/Faq/Faq';
import FeatureCarousel from '../components/FeatureCarousel/FeatureCarousel';
import FeaturedContentCards from '../components/FeaturedContentCards/FeaturedContentCards';
import FeaturedResourceCard from '../components/FeaturedResourceCard/FeaturedResourceCard';
import FloatActionWidget from '../components/FloatActionWidget/FloatActionWidget';
import FlowChartBioCellProgress from '../components/FlowChartBioCellProgress/FlowChartBioCellProgress';
import Footer from '../components/Footer/Footer';
import Formulation from '../components/Formulation/Formulation';
import GlobalLocations from '../components/GlobalLocations/GlobalLocations';
import GlobalPresenceSection from '../components/GlobalPresenceSection/GlobalPresenceSection';
import GridCardSection from '../components/GridCardSection/GridCardSection';
import Header from '../components/Header/Header';
import HeaderDesktop from '../components/Header/HeaderDesktop';
import HeaderMobile from '../components/Header/HeaderMobile';
import HealthCard from '../components/HealthCard/HealthCard';
import HeroLanding from '../components/HeroLanding/HeroLanding';
import IconFeatureGrid from '../components/IconFeatureGrid/IconFeatureGrid';
import IconList from '../components/IconList/IconList';
import ImageAndTextSection from '../components/ImageAndTextSection/ImageAndTextSection';
import ImageTextCard from '../components/ImageTextCard/ImageTextCard';
import InfoCardRow from '../components/InfoCardRow/InfoCardRow';
import LeadsForm from '../components/LaedsForm/LeadsForm';
import LeadershipTeam from '../components/LeadershipTeam/LeadershipTeam';
import LecturerIntroduction from '../components/LecturerIntroduction/LecturerIntroduction';
import LocationGrid from '../components/LocationGrid/LocationGrid';
import Locations from '../components/Locations/Locations';
import mapCard from '../components/Locations/mapCard';
import MediaVideo from '../components/MediaVideo/MediaVideo';
import MiniBanner from '../components/MiniBanner/MiniBanner';
import MissionVisionCard from '../components/MissionVisionCard/MissionVisionCard';
import MultiStageProcessTimeline from '../components/MultiStageProcessTimeline/MultiStageProcessTimeline';
import News from '../components/News/News';
import NewsDetail from '../components/News/NewsDetail';
import NewsSwiper from '../components/News/NewsSwiper';
import NewsSection from '../components/NewsSection/NewsSection';
import NumbersSection from '../components/NumbersSection/NumbersSection';
import PageSectionNavLinks from '../components/PageSectionNavLinks/PageSectionNavLinks';
import Platform from '../components/Platform/Platform';
import ProcessFlow from '../components/ProcessFlow/ProcessFlow';
import ProcessScreen from '../components/ProcessScreen/ProcessScreen';
import ProcessService from '../components/ProcessService/ProcessService';
import ProcessStages from '../components/ProcessStages/ProcessStages';
import ProcessSteps from '../components/ProcessSteps/ProcessSteps';
import ProcessTimeLine from '../components/ProcessTimeLine/ProcessTimeLine';
import ProgressDiagram from '../components/ProgressDiagram/ProgressDiagram';
import RegionalContacts from '../components/RegionalContacts/RegionalContacts';
import ResourceCardGrid from '../components/ResourceCardGrid/ResourceCardGrid';
import ResourceTitleList from '../components/ResourceTitleList/ResourceTitleList';
import ResponseTimeline from '../components/ResponseTimeline/ResponseTimeline';
import Search from '../components/Search/Search';
import SectionTitle from '../components/SectionTitle/SectionTitle';
import ServiceSection from '../components/ServiceSection/ServiceSection';
import ServicesOverview from '../components/ServicesOverview/ServicesOverview';
import Sidebar from '../components/Sidebar/Sidebar';
import SiteMap from '../components/SiteMap/SiteMap';
import SiteRichText from '../components/SiteRichText/SiteRichText';
import SiteTabs from '../components/SiteTabs/SiteTabs';
import SolutionTimelineCards from '../components/SolutionTimelineCards/SolutionTimelineCards';
import SplitContentBanner from '../components/SplitContentBanner/SplitContentBanner';
import SplitLayoutFeatureSection from '../components/SplitLayoutFeatureSection/SplitLayoutFeatureSection';
import StatsBar from '../components/StatsBar/StatsBar';
import StepByStepWorkflow from '../components/StepByStepWorkflow/StepByStepWorkflow';
import StoryCard from '../components/StoryCard/StoryCard';
import TableContent from '../components/TableContent/TableContent';
import Tabs from '../components/Tabs/Tabs';
import TextAndIconSection from '../components/TextAndIconSection/TextAndIconSection';
import TextAndVideoSection from '../components/TextAndVideoSection/TextAndVideoSection';
import Touch from '../components/Touch/Touch';
import Unsubscribe from '../components/Unsubscribe/Unsubscribe';
import Videos from '../components/Videos/Videos';
import VideosDetail from '../components/Videos/VideosDetail';
import ViewportReveal from '../components/ViewportReveal';
import Webinars from '../components/Webinars/Webinars';
import WebinarsDetail from '../components/Webinars/WebinarsDetail';
import WebinarsSwiper from '../components/Webinars/WebinarsSwiper';
import WorkFlowPla from '../components/WorkFlowPla/WorkFlowPla';
import WorkflowBio from '../components/WorkflowBio/WorkflowBio';
import WorkflowCMC from '../components/WorkflowCMC/WorkflowCMC';
import WorkflowCho from '../components/WorkflowCho/WorkflowCho';
import WorkflowGMP from '../components/WorkflowGMP/WorkflowGMP';
import WorkflowRapid from '../components/WorkflowRapid/WorkflowRapid';
import WorkflowSer from '../components/WorkflowSer/WorkflowSer';
import WorkflowSta from '../components/WorkflowSta/WorkflowSta';

const components = new Map();
components.set('Accordion', Accordion);
components.set('AgendaTable', AgendaTable);
components.set('Agenda Table', AgendaTable);
components.set('ArticlePagination', ArticlePagination);
components.set('Article Pagination', ArticlePagination);
components.set('ArticleShare', ArticleShare);
components.set('Article Share', ArticleShare);
components.set('Articles', Articles);
components.set('ArticlesDetail', ArticlesDetail);
components.set('Articles Detail', ArticlesDetail);
components.set('ArticlesDetail Route', ArticlesDetail);
components.set('Articles Detail Route', ArticlesDetail);
components.set('AsymmetricCardCarousel', AsymmetricCardCarousel);
components.set('Asymmetric Card Carousel', AsymmetricCardCarousel);
components.set('BreadcrumbNavigation', BreadcrumbNavigation);
components.set('Breadcrumb Navigation', BreadcrumbNavigation);
components.set('ButtonGroup', ButtonGroup);
components.set('Button Group', ButtonGroup);
components.set('CardSection', CardSection);
components.set('Card Section', CardSection);
components.set('CardSwiper', CardSwiper);
components.set('Card Swiper', CardSwiper);
components.set('CaseStudy', CaseStudy);
components.set('Case Study', CaseStudy);
components.set('ComparisonCardGroup', ComparisonCardGroup);
components.set('Comparison Card Group', ComparisonCardGroup);
components.set('ContentCardSlider', ContentCardSlider);
components.set('Content Card Slider', ContentCardSlider);
components.set('CoreStrengthsGrid', CoreStrengthsGrid);
components.set('Core Strengths Grid', CoreStrengthsGrid);
components.set('DeliveryApproach', DeliveryApproach);
components.set('Delivery Approach', DeliveryApproach);
components.set('DocumentLibrary', DocumentLibrary);
components.set('Document Library', DocumentLibrary);
components.set('DownloadDetail', DownloadDetail);
components.set('Download Detail', DownloadDetail);
components.set('DownloadResource', DownloadResource);
components.set('Download Resource', DownloadResource);
components.set('ErrorPage', ErrorPage);
components.set('Error Page', ErrorPage);
components.set('Events', Events);
components.set('EventsDetail', EventsDetail);
components.set('Events Detail', EventsDetail);
components.set('EventsSwiper', EventsSwiper);
components.set('Events Swiper', EventsSwiper);
components.set('Upcoming', Upcoming);
components.set('Faq', Faq);
components.set('FeatureCarousel', FeatureCarousel);
components.set('Feature Carousel', FeatureCarousel);
components.set('FeaturedContentCards', FeaturedContentCards);
components.set('Featured Content Cards', FeaturedContentCards);
components.set('FeaturedResourceCard', FeaturedResourceCard);
components.set('Featured Resource Card', FeaturedResourceCard);
components.set('FloatActionWidget', FloatActionWidget);
components.set('Float Action Widget', FloatActionWidget);
components.set('FlowChartBioCellProgress', FlowChartBioCellProgress);
components.set('Flow Chart Bio Cell Progress', FlowChartBioCellProgress);
components.set('Footer', Footer);
components.set('Formulation', Formulation);
components.set('GlobalLocations', GlobalLocations);
components.set('Global Locations', GlobalLocations);
components.set('GlobalPresenceSection', GlobalPresenceSection);
components.set('Global Presence Section', GlobalPresenceSection);
components.set('GridCardSection', GridCardSection);
components.set('Grid Card Section', GridCardSection);
components.set('Header', Header);
components.set('HeaderDesktop', HeaderDesktop);
components.set('Header Desktop', HeaderDesktop);
components.set('HeaderMobile', HeaderMobile);
components.set('Header Mobile', HeaderMobile);
components.set('HealthCard', HealthCard);
components.set('Health Card', HealthCard);
components.set('HeroLanding', HeroLanding);
components.set('Hero Landing', HeroLanding);
components.set('IconFeatureGrid', IconFeatureGrid);
components.set('Icon Feature Grid', IconFeatureGrid);
components.set('IconList', IconList);
components.set('Icon List', IconList);
components.set('ImageAndTextSection', ImageAndTextSection);
components.set('Image And Text Section', ImageAndTextSection);
components.set('ImageTextCard', ImageTextCard);
components.set('Image Text Card', ImageTextCard);
components.set('InfoCardRow', InfoCardRow);
components.set('Info Card Row', InfoCardRow);
components.set('LeadsForm', LeadsForm);
components.set('Leads Form', LeadsForm);
components.set('LeadershipTeam', LeadershipTeam);
components.set('Leadership Team', LeadershipTeam);
components.set('LecturerIntroduction', LecturerIntroduction);
components.set('Lecturer Introduction', LecturerIntroduction);
components.set('LocationGrid', LocationGrid);
components.set('Location Grid', LocationGrid);
components.set('Locations', Locations);
components.set('mapCard', mapCard);
components.set('map Card', mapCard);
components.set('MediaVideo', MediaVideo);
components.set('Media Video', MediaVideo);
components.set('MiniBanner', MiniBanner);
components.set('Mini Banner', MiniBanner);
components.set('MissionVisionCard', MissionVisionCard);
components.set('Mission Vision Card', MissionVisionCard);
components.set('MultiStageProcessTimeline', MultiStageProcessTimeline);
components.set('Multi Stage Process Timeline', MultiStageProcessTimeline);
components.set('News', News);
components.set('NewsDetail', NewsDetail);
components.set('News Detail', NewsDetail);
components.set('NewsSwiper', NewsSwiper);
components.set('News Swiper', NewsSwiper);
components.set('NewsSection', NewsSection);
components.set('News Section', NewsSection);
components.set('NumbersSection', NumbersSection);
components.set('Numbers Section', NumbersSection);
components.set('PageSectionNavLinks', PageSectionNavLinks);
components.set('Page Section Nav Links', PageSectionNavLinks);
components.set('Platform', Platform);
components.set('ProcessFlow', ProcessFlow);
components.set('Process Flow', ProcessFlow);
components.set('ProcessScreen', ProcessScreen);
components.set('Process Screen', ProcessScreen);
components.set('ProcessService', ProcessService);
components.set('Process Service', ProcessService);
components.set('ProcessStages', ProcessStages);
components.set('Process Stages', ProcessStages);
components.set('ProcessSteps', ProcessSteps);
components.set('Process Steps', ProcessSteps);
components.set('ProcessTimeLine', ProcessTimeLine);
components.set('Process Time Line', ProcessTimeLine);
components.set('ProgressDiagram', ProgressDiagram);
components.set('Progress Diagram', ProgressDiagram);
components.set('RegionalContacts', RegionalContacts);
components.set('Regional Contacts', RegionalContacts);
components.set('ResourceCardGrid', ResourceCardGrid);
components.set('Resource Card Grid', ResourceCardGrid);
components.set('ResourceTitleList', ResourceTitleList);
components.set('Resource Title List', ResourceTitleList);
components.set('ResponseTimeline', ResponseTimeline);
components.set('Response Timeline', ResponseTimeline);
components.set('Search', Search);
components.set('SectionTitle', SectionTitle);
components.set('Section Title', SectionTitle);
components.set('ServiceSection', ServiceSection);
components.set('Service Section', ServiceSection);
components.set('ServicesOverview', ServicesOverview);
components.set('Services Overview', ServicesOverview);
components.set('Sidebar', Sidebar);
components.set('SiteMap', SiteMap);
components.set('Site Map', SiteMap);
components.set('SiteRichText', SiteRichText);
components.set('Site Rich Text', SiteRichText);
components.set('SiteTabs', SiteTabs);
components.set('Site Tabs', SiteTabs);
components.set('SolutionTimelineCards', SolutionTimelineCards);
components.set('Solution Timeline Cards', SolutionTimelineCards);
components.set('SplitContentBanner', SplitContentBanner);
components.set('Split Content Banner', SplitContentBanner);
components.set('SplitLayoutFeatureSection', SplitLayoutFeatureSection);
components.set('Split Layout Feature Section', SplitLayoutFeatureSection);
components.set('StatsBar', StatsBar);
components.set('Stats Bar', StatsBar);
components.set('StepByStepWorkflow', StepByStepWorkflow);
components.set('Step By Step Workflow', StepByStepWorkflow);
components.set('StoryCard', StoryCard);
components.set('Story Card', StoryCard);
components.set('TableContent', TableContent);
components.set('Table Content', TableContent);
components.set('Tabs', Tabs);
components.set('TextAndIconSection', TextAndIconSection);
components.set('Text And Icon Section', TextAndIconSection);
components.set('TextAndVideoSection', TextAndVideoSection);
components.set('Text And Video Section', TextAndVideoSection);
components.set('Touch', Touch);
components.set('Unsubscribe', Unsubscribe);
components.set('Videos', Videos);
components.set('VideosDetail', VideosDetail);
components.set('Videos Detail', VideosDetail);
components.set('ViewportReveal', ViewportReveal);
components.set('Viewport Reveal', ViewportReveal);
components.set('Webinars', Webinars);
components.set('WebinarsDetail', WebinarsDetail);
components.set('Webinars Detail', WebinarsDetail);
components.set('WebinarsSwiper', WebinarsSwiper);
components.set('Webinars Swiper', WebinarsSwiper);
components.set('WorkFlowPla', WorkFlowPla);
components.set('Work Flow Pla', WorkFlowPla);
components.set('WorkflowBio', WorkflowBio);
components.set('Workflow Bio', WorkflowBio);
components.set('WorkflowCMC', WorkflowCMC);
components.set('Workflow CMC', WorkflowCMC);
components.set('WorkflowCho', WorkflowCho);
components.set('Workflow Cho', WorkflowCho);
components.set('WorkflowGMP', WorkflowGMP);
components.set('Workflow GMP', WorkflowGMP);
components.set('WorkflowRapid', WorkflowRapid);
components.set('Workflow Rapid', WorkflowRapid);
components.set('WorkflowSer', WorkflowSer);
components.set('Workflow Ser', WorkflowSer);
components.set('WorkflowSta', WorkflowSta);
components.set('Workflow Sta', WorkflowSta);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
